// extracted by mini-css-extract-plugin
module.exports = {"card":"BrandCard_card__3SYW9","mainImage":"BrandCard_mainImage__2IeSF"};